import React from "react";
import { Box, Grid } from "@mui/material";
import { StyledMenuTitle, StyledMenuSubtitle, StyledMenuHeading, StyledMenuButton, StyledMenuLink } from "../../style";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router";
import { StyledPaper } from "@hcl-commerce-store-sdk/react-component";
import { HeaderMegaMenuSX } from "../../../headerMegaMenu";
import useFetchWpPosts from "../../../../../_foundation/hooks/use-wordpress-posts";
import AdviceSlider from "../../../../elements/inspiration/advice/AdviceSlider";
import { DesktopActionCard } from "../DesktopActionCards";
import { PRISEDERDV, SERVICES } from "../../../../../constants/routes";
import AsyncCall from "../../../../../_foundation/gtm/async.service";
import { CLICK } from "../../../../../_foundation/constants/gtm";

interface DesktopInspirationProps {
  closeHeaderMenu?: () => any;
  menuLinksData: Record<string, any>;
}

const DesktopInspirationMenu: React.FC<DesktopInspirationProps> = ({ closeHeaderMenu, menuLinksData }) => {
  const navigate = useNavigate();
  const InspirationData = menuLinksData?.magazine;
  const NAV_LEVEL_1 = "Inspiration & Conseils";

  const { data } = useFetchWpPosts(!!InspirationData?.postsId, {
    postsId: InspirationData?.postsId,
    postsNbr: 4,
  });

  const onSeeMoreBtnClick = () => {
    AsyncCall.sendClick(CLICK.NAV, {
      click_section: "menu",
      nav_level_1: NAV_LEVEL_1,
      nav_level_2: "",
      nav_level_3: "",
      nav_type: "cta",
      btn_label: "Voir tous nos articles",
      click_destination: InspirationData?.url || "",
    });
    closeHeaderMenu && closeHeaderMenu();
    navigate(InspirationData?.url);
  };

  const onParUniverseItemClick = (item: Record<string, any>) => {
    AsyncCall.sendClick(CLICK.NAV, {
      click_section: "menu",
      nav_level_1: NAV_LEVEL_1,
      nav_level_2: "Par univers",
      nav_level_3: item?.label || "",
      nav_type: "link",
      btn_label: item?.label || "",
      click_destination: item?.link || "",
    });
    closeHeaderMenu && closeHeaderMenu();
    navigate(item?.link);
  };

  const onParTypeItemClick = (item: Record<string, any>) => {
    AsyncCall.sendClick(CLICK.NAV, {
      click_section: "menu",
      nav_level_1: NAV_LEVEL_1,
      nav_level_2: "Par type",
      nav_level_3: item?.label || "",
      nav_type: "link",
      btn_label: item?.label || "",
      click_destination: item?.link || "",
    });
    closeHeaderMenu && closeHeaderMenu();
    navigate(item?.link);
  };

  return (
    <StyledPaper className="megamenu-wrapper expanded-menu-mega-menu-v2" sx={HeaderMegaMenuSX.wrapper}>
      <Box>
        {/* Page title */}
        <StyledMenuTitle sx={{ mb: 8 }}>{InspirationData?.label}</StyledMenuTitle>

        <StyledMenuSubtitle sx={{ mb: 8 }}>{InspirationData?.description}</StyledMenuSubtitle>

        <Grid container spacing={4}>
          {/* LEFT – ARTICLE CARDS */}
          <Grid item xs={12} lg={8} md={8} sx={{ ml: 3 }}>
            <Grid container spacing={3}>
              <AdviceSlider data={data} isMenu={true} />
            </Grid>

            {/* Buttons + taxonomy */}
            <Box sx={{ mt: 5, mb: 2 }}>
              <StyledMenuButton
                sx={{
                  fontSize: "12px", // smaller text
                  padding: "4px 10px", // reduce button height & width
                  minHeight: "28px", // shrink height
                  "& svg": {
                    fontSize: "16px", // smaller icon
                    ml: 0.5,
                  },
                }}
                onClick={onSeeMoreBtnClick}>
                Voir tous nos articles
                <ArrowForwardIcon />
              </StyledMenuButton>
            </Box>

            <Grid container spacing={2} style={{ marginTop: "-8px" }}>
              <Grid item xs={12} sm={6}>
                <StyledMenuHeading sx={{ mb: -2 }}>Par univers</StyledMenuHeading>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  {InspirationData?.univers?.map((item, index) => (
                    <StyledMenuLink
                      key={index}
                      onClick={() => onParUniverseItemClick(item)}
                      sx={{ mb: -0.5 }}
                      style={{
                        cursor: "pointer",
                        margin: "4px 0px",

                        color: "#000",
                        fontFamily: "Montserrat",
                        fontSize: "15px",
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: "20px",
                      }}>
                      {item?.icon?.length > 0 && (
                        <Box
                          component="img"
                          src={item.icon}
                          sx={{
                            width: 20,
                            height: 20,
                            mr: 1,
                            objectFit: "contain",
                          }}
                        />
                      )}
                      {item.label}
                    </StyledMenuLink>
                  ))}
                </Box>
              </Grid>

              <Grid item xs={12} sm={6}>
                <StyledMenuHeading sx={{ mb: -2 }}>Par type</StyledMenuHeading>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  {InspirationData?.type?.map((item, index) => (
                    <StyledMenuLink
                      key={index}
                      onClick={() => onParTypeItemClick(item)}
                      sx={{ mb: -0.5 }}
                      style={{
                        cursor: "pointer",
                        margin: "4px 0px",

                        /* 🔽 REQUIRED CSS */
                        color: "#000",
                        fontFamily: "Montserrat",
                        fontSize: "15px",
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: "20px",
                      }}>
                      {item?.icon?.length > 0 && (
                        <Box
                          component="img"
                          src={item.icon}
                          sx={{
                            width: 20,
                            height: 20,
                            mr: 1,
                            objectFit: "contain",
                          }}
                        />
                      )}
                      {item.label}
                    </StyledMenuLink>
                  ))}
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Box
            sx={{
              width: "2px",
              backgroundColor: "#EFEFEF",
              ml: 6,
            }}
          />
          {/* RIGHT – Blue + Red Cards */}
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "start",
              // gap: 1,
              flexBasis: { md: "280px" },
              maxWidth: { md: "280px" },
              "@media (max-width:1000px)": {
                width: "265px",
                marginTop: "-10px",
                maxWidth: "265px",
                flexBasis: "265px",
              },
              flexGrow: 0,
              gap: 4,
              mt: { xs: 3, sm: -16, lg: -5, md: -5 },
              ml: 3,
              // "@media (max-width: 1200px)": {
              //   display: "none",
              // },
            }}>
            <DesktopActionCard
              closeHeaderMenu={closeHeaderMenu}
              cardTheme="red"
              chipName="AIDE"
              title="BESOIN DE CONSEIL"
              desc="Nos équipes sont là pour vous conseiller à chaque étape de votre projet."
              ctaLink={PRISEDERDV}
              btnLabel="PRENDRE RENDEZ-VOUS"
              rdvTracking={{
                navigation_location: "menu",
                click_destination: PRISEDERDV,
              }}
            />
            <DesktopActionCard
              closeHeaderMenu={closeHeaderMenu}
              cardTheme="blue"
              chipName="SERVICES"
              title="LAPEYRE À VOS CÔTÉS"
              desc="Lapeyre vous accompagne à toutes les étapes de votre projet. Découvrez tous nos services."
              ctaLink={SERVICES}
              btnLabel="DÉCOUVRIR NOS SERVICES"
              gtmData={{
                click_section: "menu",
                nav_level_1: NAV_LEVEL_1,
                nav_level_2: "",
                nav_level_3: "",
                nav_type: "cta",
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </StyledPaper>
  );
};

export default DesktopInspirationMenu;
